import React from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import Constant, { nameMaxLength, toCamelCase } from '../../Constant.js'
import axios from 'axios'

class TopEventCategoryAdd extends React.Component {
  state = {
    category_id: '',
    company_id: '',
    event_id: '',
    category_type: 'EVENT',
    name_ar: '',
    name_en: '',
    order: '1',
    image: null,
    isSaving: false,
    isData: false,
    Edit: false,
    categoryList: [],
    companyList: [],
    eventList: [],
  }

  componentDidMount() {
    if (this.props.category_id) {
      this.getUpdateData(this.props.category_id)
    } else {
      this.loadCategories(this.state.category_type)
    }
  }

  getUpdateData = async (id) => {
    await axios
      .get(Constant.getAPI() + `/event-categories/list-top-event-categories`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data?.success) {
          const matchItem = res?.data?.data?.filter((itm) => itm?.id === id)

          if (matchItem?.length > 0) {
            const itm = matchItem[0]
            this.setState({
              ...itm,
            })
            this.loadCategories(itm.category_type)
            this.loadCompanyData(itm.category_id)
            this.loadEventData(itm.company_id)

            this.setState({
              ...itm,
            })
            this.setState({ Edit: true })
          }
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value })

    if (event.target.name == 'category_type') {
      this.loadCategories(event.target.value)
    } else if (event.target.name == 'category_id') {
      this.loadCompanyData(event.target.value)
    } else if (event.target.name == 'company_id') {
      this.loadEventData(event.target.value)
    }
  }

  handleChangeImage = ({ target: { name, files } }) => {
    this.setState({
      [name]: files[0],
    })
  }

  loadCategories = async (type) => {
    await axios
      .get(Constant.getAPI() + `/event-categories/categories-v2/${type}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data?.success) {
          this.setState({
            categoryList: res.data?.data,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  loadCompanyData = async (id) => {
    this.setState({
      companyList: [],
    })
    if (id) {
      await axios
        .get(Constant.getAPI() + `/event-companies/list-event-companies-v2/${this.state.category_type}/${id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          if (res.data?.success) {
            this.setState({
              companyList: res.data?.data,
            })
          }
        })
        .catch((err) => {
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    }
  }

  loadEventData = async (id) => {
    this.setState({
      eventList: [],
    })
    if (id) {
      // await axios.get(Constant.getAPI() + `/event/list-events-by-company/${this.state.category_type}/${id}`, {
      await axios
        .get(
          Constant.getAPI() + `/event/list-company-events/${this.state.category_type}/${id}/${this.state.category_id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
              country_short_name: `${localStorage.getItem('countryShortName')}`,
            },
          }
        )
        .then((res) => {
          if (res.data?.success) {
            this.setState({
              eventList: res.data?.data,
            })
          }
        })
        .catch((err) => {
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    }
  }

  onSaveData = () => {
    const formData = new FormData()
    formData.append('category_id', this.state.category_id)
    formData.append('category_type', this.state.category_type)

    formData.append('name_ar', this.state.name_ar)
    formData.append('name_en', toCamelCase(this.state.name_en))
    formData.append('order', this.state.order)

    formData.append('company_id', this.state.company_id)
    if (this.state.company_id == '') {
      formData.append('event_id', '')
    } else {
      formData.append('event_id', this.state.event_id)
    }

    if (this.state.image && typeof this.state.image == 'object') {
      formData.append('image', this.state.image)
    }

    this.setState({ isData: true })

    if (this.props.category_id) {
      formData.append('id', this.props.category_id)

      axios
        .put(Constant.getAPI() + '/event-categories/edit-top-event-category', formData, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          this.setState({ isData: false })
          if (res.status === 200) {
            Swal.fire('Updated !', `Event Category has been Updated`, 'success')
            window.location.href = `#/top-event-category`
          }
        })
        .catch((err) => {
          this.setState({ isData: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    } else {
      axios
        .post(Constant.getAPI() + '/event-categories/add-top-event-category', formData, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          this.setState({ isData: false })
          if (res.status === 200) {
            Swal.fire('Added !', `Event Category has been Added`, 'success')
            window.location.href = `#/top-event-category`
          }
        })
        .catch((err) => {
          this.setState({ isData: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    }
  }

  render() {
    return (
      <div className="">
        <div className="card-body">
          <div className="row">
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Category Type</label>
                <div className="col-sm-9">
                  <select
                    name="category_type"
                    className="form-control"
                    value={this.state.category_type}
                    onChange={this.handleChange}
                  >
                    <option value="EVENT">EVENT</option>
                    <option value="ACTIVITY">ACTIVITY</option>
                  </select>
                </div>
              </div>
            </div>

            <div className="col-md-12">
              <hr />
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-md-3 col-form-label">Name English</label>
                <div className="col-md-9">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Name English"
                    value={this.state.name_en}
                    name="name_en"
                    maxLength={nameMaxLength}
                    onChange={this.handleChange}
                  />
                </div>
                <div className="col-sm-12 text-right">
                  {this.state.name_en ? this.state.name_en.length + ' / ' + nameMaxLength : 0 + ' / ' + nameMaxLength}
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-md-3 col-form-label">Name Arabic</label>
                <div className="col-md-9">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Name Arabic"
                    value={this.state.name_ar}
                    name="name_ar"
                    maxLength={nameMaxLength}
                    onChange={this.handleChange}
                  />
                </div>
                <div className="col-sm-12 text-right">
                  {this.state.name_ar ? this.state.name_ar.length + ' / ' + nameMaxLength : 0 + ' / ' + nameMaxLength}
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Category</label>
                <div className="col-sm-9">
                  <select
                    name="category_id"
                    className="form-control"
                    value={this.state.category_id}
                    onChange={this.handleChange}
                  >
                    <option value="">Select Category</option>
                    {this.state.categoryList !== undefined &&
                    this.state.categoryList !== null &&
                    this.state.categoryList !== [] &&
                    this.state.categoryList.length > 0
                      ? this.state.categoryList.map((category) => (
                          <option
                            value={category.id}
                            key={category.id}
                          >
                            {category.category_name_en}
                          </option>
                        ))
                      : null}
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-md-3 col-form-label">Order No.</label>
                <div className="col-md-9">
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Order No."
                    value={this.state.order}
                    name="order"
                    onChange={this.handleChange}
                  />
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Company</label>
                <div className="col-sm-9">
                  <select
                    name="company_id"
                    className="form-control"
                    value={this.state.company_id}
                    onChange={this.handleChange}
                  >
                    <option value="">Select Company</option>
                    {this.state.companyList !== undefined &&
                    this.state.companyList !== null &&
                    this.state.companyList !== [] &&
                    this.state.companyList.length > 0
                      ? this.state.companyList.map((company) => (
                          <option
                            value={company.id}
                            key={company.id}
                          >
                            {company.company_short_name || company.company_name}
                          </option>
                        ))
                      : null}
                  </select>
                  <span style={{ fontSize: 14, color: 'red' }}>
                    If Company is selected, then user will get redirected to company's event list page, Otherwise
                    Company list will shown according to category.
                  </span>
                </div>
              </div>
            </div>

            <div className="col-md-6"></div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Event (Optional)</label>
                <div className="col-sm-9">
                  <select
                    name="event_id"
                    className="form-control"
                    value={this.state.event_id}
                    onChange={this.handleChange}
                  >
                    <option value="">Select Event</option>
                    {this.state.eventList !== undefined &&
                    this.state.eventList !== null &&
                    this.state.eventList !== [] &&
                    this.state.eventList.length > 0
                      ? this.state.eventList.map((event) => (
                          <option
                            value={event.id}
                            key={event.id}
                          >
                            {event.event_name_en}
                          </option>
                        ))
                      : null}
                  </select>
                  <span style={{ fontSize: 14, color: 'red' }}>
                    If event is selected, then user will get redirected to event details page, otherwise events list
                    will be shown.
                  </span>
                </div>
              </div>
            </div>

            <div className="col-12">
              <hr />
            </div>

            <div className="col-md-6">
              <div className="row">
                <div className="col-sm-3">Image</div>
                <div className="col-sm-9">
                  <div className="form-group">
                    <div>
                      <input
                        type="file"
                        id="img"
                        name="image"
                        accept="image/*"
                        className="w-100"
                        onChange={this.handleChangeImage}
                        ref={(ref) => (this.image_input = ref)}
                      />
                    </div>
                    <div style={{ color: 'red' }}>Image height width must be 1 : 1 Ratio or 512 x 512</div>
                    <div style={{ color: 'red' }}>Image size should not be more then 1 MB</div>
                  </div>
                  {this.state.image ? (
                    typeof this.state.image == 'object' ? (
                      <img
                        width="200px"
                        src={URL.createObjectURL(this.state.image)}
                        alt="img"
                        onError={({ currentTarget }) => {
                          currentTarget.src = './assets/images/no_image.png'
                        }}
                      />
                    ) : (
                      <img
                        width="200px"
                        src={Constant.getImage() + this.state.image}
                        alt="img"
                        onError={({ currentTarget }) => {
                          currentTarget.src = './assets/images/no_image.png'
                        }}
                      />
                    )
                  ) : (
                    <img
                      width="200px"
                      src="./assets/images/no_image.png"
                      alt="img"
                    />
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="row float-right p-3">
            {this.state.isData ? (
              <button className="btn btn-grd-disabled mr-2">Saving...!</button>
            ) : (
              <button
                onClick={this.onSaveData}
                className="btn btn-grd-disabled mr-2"
              >
                <i className="icofont icofont-save"></i> Save
              </button>
            )}
            <Link
              to={`/top-event-category`}
              className="btn btn-outline-dark"
            >
              Cancel
            </Link>
          </div>
        </div>
      </div>
    )
  }
}

export default TopEventCategoryAdd
